import React from 'react';
import { Tooltip } from 'common/components/Tooltip/Tooltip';
import { useTranslation } from 'react-i18next';

type IconCellProps = {
  title: string | null;
  children: React.ReactElement;
  disabled?: boolean;
  disabledLabel?: string;
};

export const TooltipCell: React.FC<IconCellProps> = ({
  title,
  children,
  disabled = false,
  disabledLabel,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {!!title || disabled ? (
        <Tooltip
          showArrow={true}
          title={
            disabled ? disabledLabel ?? t('customFields.unavailableWhileEditing') : title ?? ''
          }
          variant="dark"
        >
          {children}
        </Tooltip>
      ) : (
        <>{children}</>
      )}
    </>
  );
};
